import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

const CommunityNoData = ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width="120"
    height="109"
    viewBox="0 0 120 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6535_1113211)">
      <mask
        id="mask0_6535_1113211"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="25"
        y="0"
        width="71"
        height="71"
      >
        <path d="M25 7.62939e-06H96V71H25V7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6535_1113211)">
        <path
          d="M84.1419 5.23804C86.4408 5.23804 88.3031 7.10124 88.3031 9.40125C88.3031 11.6975 86.4408 13.5645 84.1419 13.5645C81.843 13.5645 79.9805 11.6975 79.9805 9.40125C79.9805 7.10124 81.843 5.23804 84.1419 5.23804Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.7832 18.4414C77.7832 15.8707 79.3288 13.6442 81.535 12.643M86.7511 12.643C88.9572 13.6442 90.5029 15.8707 90.5029 18.4414"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.1415 20.7695C89.57 20.7695 94.0018 16.3356 94.0018 10.9044C94.0018 5.46945 89.57 1.03944 84.1415 1.03944C78.709 1.03944 74.2812 5.46945 74.2812 10.9044C74.2812 16.3356 78.709 20.7695 84.1415 20.7695Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.7532 54.4275C87.0521 54.4275 88.9145 56.2946 88.9145 58.5907C88.9145 60.8907 87.0521 62.7539 84.7532 62.7539C82.458 62.7539 80.5918 60.8907 80.5918 58.5907C80.5918 56.2946 82.458 54.4275 84.7532 54.4275Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3926 67.6367C78.3926 65.066 79.9382 62.8356 82.1443 61.8344M87.3642 61.8344C89.5704 62.8356 91.1123 65.066 91.1123 67.6367"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.7528 69.959C90.1853 69.959 94.6131 65.529 94.6131 60.094C94.6131 54.6628 90.1853 50.2289 84.7528 50.2289C79.3243 50.2289 74.8926 54.6628 74.8926 60.094C74.8926 65.529 79.3243 69.959 84.7528 69.959Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M76.6355 26.8465C76.5621 26.7151 76.4886 26.5799 76.4114 26.4523C73.2083 20.9979 67.2814 17.3332 60.5004 17.3332C50.3154 17.3332 42.0625 25.594 42.0625 35.7799C42.0625 45.9696 50.3154 54.2305 60.5004 54.2305C70.6853 54.2305 78.9383 45.9696 78.9383 35.7799C78.9383 34.2607 78.7567 32.784 78.4089 31.3693"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.4507 50.623V49.3165C71.4507 45.0218 68.0081 44.3685 65.087 43.5683C64.0554 43.2901 63.785 41.9602 63.5723 41.5312M57.4291 41.5312C57.2166 41.9602 56.946 43.2901 55.9144 43.5683C52.9933 44.3685 49.5508 45.0218 49.5508 49.3165V50.623"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.3392 32.0999V34.4966C68.3392 37.3108 65.6964 40.844 62.4625 42.0423C61.0445 42.5719 59.9549 42.5719 58.5368 42.0423C55.3028 40.844 52.6602 37.3108 52.6602 34.4966V32.0999"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.5645 43.9357L59.4367 46.7923C60.2636 47.3297 60.7348 47.3297 61.5617 46.7923L66.4339 43.9357"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.262 24.0051C58.2819 23.5219 59.3909 23.2744 60.4998 23.2551C64.4215 23.3208 68.3394 26.2741 68.3394 32.0996C65.1672 31.8754 65.6386 29.4517 63.4477 30.0161C61.7555 30.4529 61.1297 30.6732 60.4998 30.6732C59.87 30.6732 59.244 30.4529 57.5518 30.0161C55.3609 29.4517 55.8323 31.8754 52.6602 32.0996C52.6602 29.9929 53.1702 28.261 54.0125 26.9082"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.2168 18.488L47.4631 22.7363"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.5371 22.7324L77.7834 18.4416"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.2168 53.0703L47.4631 48.8258"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.5371 48.8303L77.7834 53.1211"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.2832 35.7793H42.0627"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M83.717 35.7793H78.9375"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.5 59.0117V54.23"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.5 12.5503V17.332"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.2833 35.7787C37.2833 32.837 34.8954 30.4519 31.9551 30.4519C29.0147 30.4519 26.627 32.837 26.627 35.7787C26.627 38.7242 29.0147 41.1094 31.9551 41.1094C34.8954 41.1094 37.2833 38.7242 37.2833 35.7787Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M83.7168 35.7787C83.7168 32.837 86.1047 30.4519 89.045 30.4519C91.9854 30.4519 94.3732 32.837 94.3732 35.7787C94.3732 38.7242 91.9854 41.1094 89.045 41.1094C86.1047 41.1094 83.7168 38.7242 83.7168 35.7787Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.5001 59.0124C63.4403 59.0124 65.8283 61.3976 65.8283 64.3392C65.8283 67.2849 63.4403 69.6699 60.5001 69.6699C57.5598 69.6699 55.1719 67.2849 55.1719 64.3392C55.1719 61.3976 57.5598 59.0124 60.5001 59.0124Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.5001 12.5508C63.4403 12.5508 65.8283 10.1656 65.8283 7.2201C65.8283 4.27831 63.4403 1.89329 60.5001 1.89329C57.5598 1.89329 55.1719 4.27831 55.1719 7.2201C55.1719 10.1656 57.5598 12.5508 60.5001 12.5508Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.2472 54.3806C38.5424 54.3806 40.4086 56.2438 40.4086 58.5438C40.4086 60.8438 38.5424 62.707 36.2472 62.707C33.9483 62.707 32.0859 60.8438 32.0859 58.5438C32.0859 56.2438 33.9483 54.3806 36.2472 54.3806Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.8867 67.5859C29.8867 65.0152 31.4285 62.7887 33.6346 61.7875M38.8546 61.7875C41.0608 62.7887 42.6064 65.0152 42.6064 67.5859"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.247 69.9121C41.6756 69.9121 46.1072 65.4782 46.1072 60.047C46.1072 54.612 41.6756 50.182 36.247 50.182C30.8145 50.182 26.3867 54.612 26.3867 60.047C26.3867 65.4782 30.8145 69.9121 36.247 69.9121Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.8566 5.23804C39.1555 5.23804 41.018 7.10124 41.018 9.40125C41.018 11.6975 39.1555 13.5645 36.8566 13.5645C34.5577 13.5645 32.6953 11.6975 32.6953 9.40125C32.6953 7.10124 34.5577 5.23804 36.8566 5.23804Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.498 18.4414C30.498 15.8707 32.0437 13.6442 34.2498 12.643M39.466 12.643C41.6721 13.6442 43.2177 15.8707 43.2177 18.4414"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.8583 20.7695C42.2908 20.7695 46.7186 16.3356 46.7186 10.9044C46.7186 5.46945 42.2908 1.03944 36.8583 1.03944C31.4299 1.03944 26.998 5.46945 26.998 10.9044C26.998 16.3356 31.4299 20.7695 36.8583 20.7695Z"
          stroke="#2C3236"
          
          className="dark:stroke-caption"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <path
      d="M3.22425 103V91.8H4.63225L9.59225 99.768C9.67225 99.9013 9.74958 100.035 9.82425 100.168C9.89892 100.301 9.97625 100.445 10.0563 100.6C10.0509 100.461 10.0429 100.323 10.0323 100.184C10.0269 100.045 10.0243 99.912 10.0243 99.784V91.8H11.4163V103H10.0723L5.03225 95C4.96292 94.8773 4.88825 94.7493 4.80825 94.616C4.73358 94.4827 4.65892 94.3493 4.58425 94.216C4.59492 94.3333 4.60292 94.4613 4.60825 94.6C4.61358 94.7387 4.61625 94.872 4.61625 95V103H3.22425ZM17.4796 103.192C16.3596 103.192 15.477 102.811 14.8316 102.048C14.1863 101.28 13.8636 100.237 13.8636 98.92C13.8636 98.04 14.0103 97.28 14.3036 96.64C14.597 96 15.013 95.5067 15.5516 95.16C16.0956 94.808 16.7383 94.632 17.4796 94.632C18.2263 94.632 18.869 94.8053 19.4076 95.152C19.9516 95.4933 20.3676 95.984 20.6556 96.624C20.949 97.264 21.0956 98.024 21.0956 98.904C21.0956 99.784 20.949 100.547 20.6556 101.192C20.3623 101.832 19.9436 102.325 19.3996 102.672C18.861 103.019 18.221 103.192 17.4796 103.192ZM17.4796 101.896C18.1676 101.896 18.7063 101.632 19.0956 101.104C19.4903 100.571 19.6876 99.8373 19.6876 98.904C19.6876 97.9653 19.4903 97.232 19.0956 96.704C18.7063 96.176 18.1676 95.912 17.4796 95.912C16.7863 95.912 16.245 96.176 15.8556 96.704C15.4663 97.2267 15.2716 97.9653 15.2716 98.92C15.2716 99.8533 15.4663 100.584 15.8556 101.112C16.245 101.635 16.7863 101.896 17.4796 101.896ZM27.2711 103V91.8H30.3271C31.2871 91.8 32.0978 91.96 32.7591 92.28C33.4258 92.6 33.9618 93.0293 34.3671 93.568C34.7725 94.1013 35.0658 94.7013 35.2471 95.368C35.4338 96.0293 35.5271 96.7067 35.5271 97.4C35.5271 98.0453 35.4418 98.696 35.2711 99.352C35.1005 100.008 34.8151 100.613 34.4151 101.168C34.0205 101.717 33.4845 102.16 32.8071 102.496C32.1298 102.832 31.2818 103 30.2631 103H27.2711ZM28.6631 101.704H30.4391C31.1378 101.704 31.7191 101.579 32.1831 101.328C32.6525 101.072 33.0258 100.736 33.3031 100.32C33.5858 99.8987 33.7858 99.4347 33.9031 98.928C34.0258 98.416 34.0871 97.9067 34.0871 97.4C34.0871 96.856 34.0205 96.328 33.8871 95.816C33.7591 95.2987 33.5538 94.8347 33.2711 94.424C32.9938 94.0133 32.6365 93.688 32.1991 93.448C31.7618 93.2027 31.2338 93.08 30.6151 93.08H28.6631V101.704ZM40.0241 103.192C39.1388 103.192 38.4428 102.947 37.9361 102.456C37.4295 101.965 37.1761 101.293 37.1761 100.44C37.1761 99.8907 37.3015 99.4133 37.5521 99.008C37.8028 98.6027 38.1575 98.2907 38.6161 98.072C39.0748 97.848 39.6135 97.736 40.2321 97.736C40.6321 97.736 41.0055 97.7813 41.3521 97.872C41.7041 97.9573 42.0348 98.088 42.3441 98.264V97.688C42.3441 97.0533 42.2001 96.5893 41.9121 96.296C41.6241 95.9973 41.1761 95.848 40.5681 95.848C40.1788 95.848 39.7735 95.92 39.3521 96.064C38.9361 96.208 38.5468 96.408 38.1841 96.664L37.7841 95.496C38.1948 95.224 38.6615 95.0133 39.1841 94.864C39.7121 94.7093 40.2321 94.632 40.7441 94.632C41.7148 94.632 42.4428 94.88 42.9281 95.376C43.4135 95.8667 43.6561 96.6 43.6561 97.576V103H42.3441V102.248C42.0241 102.552 41.6641 102.787 41.2641 102.952C40.8641 103.112 40.4508 103.192 40.0241 103.192ZM40.2321 101.976C40.6108 101.976 40.9841 101.883 41.3521 101.696C41.7255 101.509 42.0561 101.245 42.3441 100.904V99.496C42.0721 99.3253 41.7628 99.192 41.4161 99.096C41.0695 99 40.7388 98.952 40.4241 98.952C39.8268 98.952 39.3548 99.088 39.0081 99.36C38.6615 99.6267 38.4881 99.992 38.4881 100.456C38.4881 100.925 38.6428 101.296 38.9521 101.568C39.2615 101.84 39.6881 101.976 40.2321 101.976ZM48.1156 103.192C47.5556 103.192 47.1263 103.024 46.8276 102.688C46.5343 102.352 46.3876 101.869 46.3876 101.24V96.04H45.0596V94.824H46.3876V92.12L47.7796 91.448V94.824H49.7956V96.04H47.7796V100.776C47.7796 101.165 47.8463 101.451 47.9796 101.632C48.1183 101.808 48.3343 101.896 48.6276 101.896C49.001 101.896 49.4063 101.752 49.8436 101.464L49.6836 102.824C49.4436 102.952 49.193 103.045 48.9316 103.104C48.6756 103.163 48.4036 103.192 48.1156 103.192ZM54.1023 103.192C53.2169 103.192 52.5209 102.947 52.0143 102.456C51.5076 101.965 51.2543 101.293 51.2543 100.44C51.2543 99.8907 51.3796 99.4133 51.6303 99.008C51.8809 98.6027 52.2356 98.2907 52.6943 98.072C53.1529 97.848 53.6916 97.736 54.3103 97.736C54.7103 97.736 55.0836 97.7813 55.4303 97.872C55.7823 97.9573 56.1129 98.088 56.4223 98.264V97.688C56.4223 97.0533 56.2783 96.5893 55.9903 96.296C55.7023 95.9973 55.2543 95.848 54.6463 95.848C54.2569 95.848 53.8516 95.92 53.4303 96.064C53.0143 96.208 52.6249 96.408 52.2623 96.664L51.8623 95.496C52.2729 95.224 52.7396 95.0133 53.2623 94.864C53.7903 94.7093 54.3103 94.632 54.8223 94.632C55.7929 94.632 56.5209 94.88 57.0063 95.376C57.4916 95.8667 57.7343 96.6 57.7343 97.576V103H56.4223V102.248C56.1023 102.552 55.7423 102.787 55.3423 102.952C54.9423 103.112 54.5289 103.192 54.1023 103.192ZM54.3103 101.976C54.6889 101.976 55.0623 101.883 55.4303 101.696C55.8036 101.509 56.1343 101.245 56.4223 100.904V99.496C56.1503 99.3253 55.8409 99.192 55.4943 99.096C55.1476 99 54.8169 98.952 54.5023 98.952C53.9049 98.952 53.4329 99.088 53.0863 99.36C52.7396 99.6267 52.5663 99.992 52.5663 100.456C52.5663 100.925 52.7209 101.296 53.0303 101.568C53.3396 101.84 53.7663 101.976 54.3103 101.976ZM62.7691 103L66.7371 91.8H68.0331L72.0011 103H70.5771L69.6171 100.264H65.1691L64.2251 103H62.7691ZM65.5851 99.032H69.1851L67.7451 94.888C67.7078 94.7813 67.6651 94.6587 67.6171 94.52C67.5745 94.376 67.5318 94.2373 67.4891 94.104C67.4465 93.9653 67.4145 93.848 67.3931 93.752C67.3665 93.848 67.3318 93.9653 67.2891 94.104C67.2518 94.2373 67.2091 94.376 67.1611 94.52C67.1185 94.6587 67.0785 94.7813 67.0411 94.888L65.5851 99.032ZM75.5276 103L72.5356 94.824H73.9436L75.8796 100.28C75.9276 100.413 75.973 100.544 76.0156 100.672C76.0583 100.8 76.0983 100.936 76.1356 101.08C76.1783 100.936 76.2183 100.8 76.2556 100.672C76.2983 100.544 76.3436 100.413 76.3916 100.28L78.2956 94.824H79.6876L76.6956 103H75.5276ZM83.5866 103.192C82.7013 103.192 82.0053 102.947 81.4986 102.456C80.992 101.965 80.7386 101.293 80.7386 100.44C80.7386 99.8907 80.864 99.4133 81.1146 99.008C81.3653 98.6027 81.72 98.2907 82.1786 98.072C82.6373 97.848 83.176 97.736 83.7946 97.736C84.1946 97.736 84.568 97.7813 84.9146 97.872C85.2666 97.9573 85.5973 98.088 85.9066 98.264V97.688C85.9066 97.0533 85.7626 96.5893 85.4746 96.296C85.1866 95.9973 84.7386 95.848 84.1306 95.848C83.7413 95.848 83.336 95.92 82.9146 96.064C82.4986 96.208 82.1093 96.408 81.7466 96.664L81.3466 95.496C81.7573 95.224 82.224 95.0133 82.7466 94.864C83.2746 94.7093 83.7946 94.632 84.3066 94.632C85.2773 94.632 86.0053 94.88 86.4906 95.376C86.976 95.8667 87.2186 96.6 87.2186 97.576V103H85.9066V102.248C85.5866 102.552 85.2266 102.787 84.8266 102.952C84.4266 103.112 84.0133 103.192 83.5866 103.192ZM83.7946 101.976C84.1733 101.976 84.5466 101.883 84.9146 101.696C85.288 101.509 85.6186 101.245 85.9066 100.904V99.496C85.6346 99.3253 85.3253 99.192 84.9786 99.096C84.632 99 84.3013 98.952 83.9866 98.952C83.3893 98.952 82.9173 99.088 82.5706 99.36C82.224 99.6267 82.0506 99.992 82.0506 100.456C82.0506 100.925 82.2053 101.296 82.5146 101.568C82.824 101.84 83.2506 101.976 83.7946 101.976ZM89.6565 103V94.824H91.0485V103H89.6565ZM90.3445 93.336C90.1045 93.336 89.8992 93.2533 89.7285 93.088C89.5632 92.9173 89.4805 92.712 89.4805 92.472C89.4805 92.2213 89.5632 92.0107 89.7285 91.84C89.8992 91.664 90.1045 91.576 90.3445 91.576C90.5952 91.576 90.8032 91.664 90.9685 91.84C91.1392 92.0107 91.2245 92.2213 91.2245 92.472C91.2245 92.712 91.1392 92.9173 90.9685 93.088C90.8032 93.2533 90.5952 93.336 90.3445 93.336ZM93.783 103V92.104L95.175 91.448V103H93.783ZM101.379 103.192C100.973 103.192 100.605 103.12 100.275 102.976C99.9438 102.832 99.6132 102.605 99.2825 102.296V103H97.8905V92.104L99.2825 91.448V95.528C99.5385 95.2453 99.8452 95.0267 100.203 94.872C100.565 94.712 100.941 94.632 101.331 94.632C102.024 94.632 102.624 94.8053 103.131 95.152C103.637 95.4987 104.029 95.992 104.307 96.632C104.584 97.272 104.723 98.0293 104.723 98.904C104.723 100.264 104.429 101.32 103.843 102.072C103.256 102.819 102.435 103.192 101.379 103.192ZM101.187 101.896C101.869 101.896 102.392 101.637 102.755 101.12C103.117 100.603 103.299 99.864 103.299 98.904C103.299 97.928 103.117 97.1867 102.755 96.68C102.397 96.168 101.875 95.912 101.187 95.912C100.819 95.912 100.456 96.016 100.099 96.224C99.7412 96.4267 99.4692 96.6853 99.2825 97V100.792C99.4852 101.128 99.7545 101.397 100.091 101.6C100.432 101.797 100.797 101.896 101.187 101.896ZM106.955 103V92.104L108.347 91.448V103H106.955ZM114.214 103.192C113.468 103.192 112.822 103.008 112.278 102.64C111.734 102.272 111.316 101.765 111.022 101.12C110.729 100.475 110.582 99.736 110.582 98.904C110.582 98.0027 110.734 97.2347 111.038 96.6C111.342 95.96 111.766 95.472 112.31 95.136C112.854 94.8 113.489 94.632 114.214 94.632C114.828 94.632 115.39 94.7707 115.902 95.048C116.414 95.32 116.822 95.744 117.126 96.32C117.436 96.8907 117.59 97.624 117.59 98.52C117.59 98.648 117.585 98.7973 117.574 98.968C117.569 99.1333 117.558 99.304 117.542 99.48H112.006C112.06 99.976 112.182 100.411 112.374 100.784C112.566 101.157 112.82 101.451 113.134 101.664C113.449 101.872 113.82 101.976 114.246 101.976C114.593 101.976 114.913 101.915 115.206 101.792C115.505 101.669 115.782 101.48 116.038 101.224L116.854 102.136C116.55 102.44 116.172 102.693 115.718 102.896C115.27 103.093 114.769 103.192 114.214 103.192ZM111.99 98.264H116.182C116.182 97.8 116.105 97.3867 115.95 97.024C115.801 96.656 115.58 96.368 115.286 96.16C114.993 95.952 114.636 95.848 114.214 95.848C113.622 95.848 113.113 96.04 112.686 96.424C112.265 96.808 112.033 97.4213 111.99 98.264Z"
      fill="#2C3236"
      className="dark:fill-caption"
    />
    <defs>
      <clipPath id="clip0_6535_1113211">
        <rect width="71" height="71" fill="white" transform="translate(25)" />
      </clipPath>
    </defs>
  </svg>
);
export default CommunityNoData;
